import {Component} from '@angular/core';
import {Router} from "@angular/router";
import {ProductResponse} from "../../../models/productResponse";
import {ImageService} from "../../../service/image.service";
import {UserService} from "../../../service/user.service";
import {ShoppingCartRequest} from "../../../models/shoppingCartRequest";
import {ShoppingCartService} from "../../../service/shoppingCart.service";
import {AttributeValueResponse} from "../../../models/attributeValueResponse";
import {ShoppingSharedService} from "../../../service/shopping-shared.service";

@Component({
  selector: 'app-product-details-page',
  templateUrl: './product-details-page.component.html',
  styleUrl: './product-details-page.component.scss'
})
export class ProductDetailsPageComponent {

  protected product: ProductResponse;
  selectedImage!: string;
  quantity: number = 1;
  selectedColor!: number;
  shoppingCartRequest!: ShoppingCartRequest

  constructor(
    private router: Router,
    private imageService: ImageService,
    private userService: UserService,
    private shoppingCartService: ShoppingCartService,
    private shoppingSharedService: ShoppingSharedService
  ) {
    this.product = <ProductResponse>this.router.getCurrentNavigation()?.extras.state?.['product'];
    this.quantity = this.router.getCurrentNavigation()?.extras.state?.['selectedQuantity'];
    this.selectedColor = this.router.getCurrentNavigation()?.extras.state?.['selectedColor'];
    this.selectedImage = this.product.imageUrls[0];
  }

  selectColor(attributeValue: AttributeValueResponse) {
    this.selectedColor = attributeValue.id;
  }

  getProductImageUrl(imageName: string) {
    return this.imageService.getImageUrl(imageName)
  }

  changeSelectedImage(image: string) {
    this.selectedImage = image;
  }

  increaseQuantity() {
    this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  get totalPriceUSD(): number {
    return this.product.convertedPrice * this.quantity;
  }

  get totalPriceAMD(): number {
    return this.product.price * this.quantity;
  }

  getColorValueById(colorId: number, attributeValues: any[]): string | null {
    const colorAttribute = attributeValues.find(attr => attr.id === colorId);
    return colorAttribute ? colorAttribute.value : null;
  }

  quickShop() {
    if (!this.userService.isLoggedIn()) {
      this.userService.setRedirectUrl(this.router.url);
      this.router.navigate(['/login']);
      return;
    }

    const selectedColorValue = this.getColorValueById(this.selectedColor, this.product.attributeValues);
    const totalSumAmd = this.totalPriceAMD;
    const totalSumUsd = this.totalPriceUSD;
    const shopData = [{
      product: this.product,
      quantity: this.quantity,
      selectedColor: selectedColorValue ?? '',
      priceAMD: this.totalPriceAMD,
      priceUSD: this.totalPriceUSD
    }];

    this.shoppingSharedService.products = shopData;
    this.shoppingSharedService.totalSumAmd = totalSumAmd;
    this.shoppingSharedService.totalSumUsd = totalSumUsd;

    this.router.navigate(['/shipping-method'], {
      state: { shopData, totalSumAmd, totalSumUsd }
    });
  }

  addToCart() {
    this.shoppingCartRequest = {
      productId: this.product.id,
      quantity: this.quantity,
      attributeValueIds: [this.selectedColor],
      isFromOutOfCart: true
    };

    if (this.userService.isLoggedIn()) {
      this.shoppingCartService.addProductToBucket(this.shoppingCartRequest).subscribe({
        next: () => {
          this.product.isAddedToCart = true;
          setTimeout(() => {
            this.product.isAddedToCart = false;
          }, 2000);
        },
        error: (err) => console.error('Failed to add to cart', err),

      });
    } else {
      this.userService.setRedirectUrl(this.router.url);
      this.router.navigate(['/login']);
    }
  }

}
